import { Component } from '@angular/core';

@Component({
  selector: 'app-verify-method',
  templateUrl: './verify-method.component.html',
  styleUrls: ['./verify-method.component.css']
})
export class VerifyMethodComponent {
  createASINType:boolean = true;

  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'
}
